import { useState } from "react";
import Chart from "react-apexcharts";
import { FiTrendingUp } from "react-icons/fi";
import useStatistics from "../../../marketplace_admin/libs/useStatistics";
import PageHeader from "../../components/PageHeader";
import StatCard from "../../components/StatCard";
import Spinner from "../../../Spinner/Spinner";
import { formatNgn } from "../../../Routes/Marketplace/libs/orderDisplayUtils";

const AdminAnalyticsPage = () => {
  const [days, setDays] = useState(30);
  const { data: statistics, isLoading, error } = useStatistics(days);

  const chartOptions = {
    chart: { toolbar: { show: false } },
    xaxis: { categories: statistics?.dailyRevenue?.map((d) => d.date.slice(5)) || [] },
    colors: ["#284697"],
    stroke: { curve: "smooth" },
  };
  const chartSeries = [{ name: "Revenue", data: statistics?.dailyRevenue?.map((d) => d.amount) || [] }];

  const donutOptions = {
    labels: ["Completed", "Pending", "Paid"],
    colors: ["#059669", "#d97706", "#284697"],
  };
  const donutSeries = statistics
    ? [statistics.completedOrders || 0, statistics.pendingOrders || 0, statistics.paidOrders || 0]
    : [];

  return (
    <>
      <PageHeader title="Analytics" subtitle="Marketplace insights and revenue trends" icon={FiTrendingUp}>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} style={{ marginTop: 8 }}>
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
      </PageHeader>
      {isLoading && <Spinner />}
      {error && <p style={{ color: "var(--dash-danger)" }}>Could not load analytics.</p>}
      {statistics && (
        <>
          <div className="dashboard-stat-grid">
            <StatCard label="GMV (all time)" value={formatNgn(statistics.totalRevenue || 0)} />
            <StatCard label="Orders" value={statistics.totalOrders} />
            <StatCard label="Merchants" value={statistics.totalMerchants} />
            <StatCard label="Customers" value={statistics.totalCustomers} />
          </div>
          <div className="dashboard-card">
            <h2 className="dashboard-card__title">Revenue trend ({days} days)</h2>
            <Chart options={chartOptions} series={chartSeries} type="area" height={300} />
          </div>
          <div className="dashboard-card">
            <h2 className="dashboard-card__title">Orders by status</h2>
            <Chart options={donutOptions} series={donutSeries} type="donut" height={280} />
          </div>
        </>
      )}
    </>
  );
};

export default AdminAnalyticsPage;
